import { createAxiosDataRequestHook, createAxiosRequestHook, useStaticAxiosInstance } from '@clover-util/use-axios';
export { useStaticAxiosDataRequest as useRequest } from '@clover-util/use-axios';

function createRequestHook(useInstance) {
    if (useInstance === void 0) { useInstance = useStaticAxiosInstance; }
    return createAxiosDataRequestHook(createAxiosRequestHook(useInstance));
}

export { createRequestHook };
